import {cloneDeep} from 'lodash';
import Vue from 'vue';

export default {
  dashboardQueryTemporary(state: any, data: any) {
    Vue.set(state.dashboard.queryTemporary, data.name, data.value);
  },
  applyDashboardQuery(state: any, data: any) {
    state.dashboard.query = cloneDeep(state.dashboard.queryTemporary);
  },
  restoreDashboardQuery(state: any, data: any) {
    state.dashboard.queryTemporary = cloneDeep(state.dashboard.query);
  },
  dashboardQuery(state: any, data: any) {
    let setToLocalStorage = !data.notSetToLocalStorage;

    if(setToLocalStorage) {
      Vue.set(state.dashboard.query, data.name, data.value);

      localStorage.setItem(
        'dashboard-query',
        JSON.stringify(state.dashboard.query)
      );
    }
  },
  dashboardQueryPeriod(state: any, period: any) {
    let setToLocalStorage = !period.notSetToLocalStorage;

      Vue.set(state.dashboard.query, 'date', period.date);
      Vue.set(state.dashboard.query, 'from', period.from);
      Vue.set(state.dashboard.query, 'to', period.to);
      Vue.set(state.dashboard.query, 'timezone', period.timezone || state.user.defaultTimezone);
    if(setToLocalStorage) {
      window.localStorage.setItem(
        'dashboard-query',
        JSON.stringify(state.dashboard.query)
      );
    }
  },
  dashboardQueryPeriodTemporary(state: any, period: any) {
    Vue.set(state.dashboard.queryTemporary, 'date', period.date);
    Vue.set(state.dashboard.queryTemporary, 'from', period.from);
    Vue.set(state.dashboard.queryTemporary, 'to', period.to);
    Vue.set(state.dashboard.queryTemporary, 'timezone', period.timezone || state.user.defaultTimezone);
  },
  dashboardDirection(state: any, val: string) {
    state.dashboard.query.direction = val;
    window.localStorage.setItem(
      'dashboard-query',
      JSON.stringify(state.dashboard.query)
    );
  },
  dashboardSortBy(state: any, sorting: { title: string; value: any }) {
    state.dashboard.sortBy = sorting.title;
    if(sorting.value) {
      state.dashboard.query.orderBy = sorting.value;
      window.localStorage.setItem(
        'dashboard-query',
        JSON.stringify(state.dashboard.query)
      );
    }
  },
};
